import React from 'react';

export const wrapHeader = (header: string) => {
	return <span style={{ whiteSpace: 'pre-wrap' }}>{header}</span>;
};
